import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';

import { Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './tooltip.module.css';

interface Props {
  text: string;
  tooltipText?: React.ReactNode;
  width?: string;
  paddingBottom?: string;
  placementBottom?: boolean;
  bold?: boolean;
  color?: string;
  fontSize?: string;
  lightTooltip?: boolean;
}

const TextOverflowTooltip = ({
  text,
  tooltipText = '',
  width = '100%',
  paddingBottom = '0',
  placementBottom = false,
  bold = false,
  fontSize = '14px',
  color = colors.neutral.dark,
  lightTooltip = false,
}: Props) => {
  const [overflowing, setOverflowing] = useState<boolean>(false);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const { offsetWidth, scrollWidth } = container.current;
    setOverflowing(offsetWidth < scrollWidth);
  }, []);

  const styles = {
    fontWeight: bold ? '500' : '400',
    fontSize,
    color,
  };

  return !R.isNil(text) ? (
    <div
      ref={container}
      className={classes.overflowContainer}
      style={{ width, paddingBottom }}
    >
      {!overflowing ? (
        <div style={styles}>{text}</div>
      ) : (
        <Tooltip
          lightTooltip={lightTooltip}
          title={tooltipText || text}
          placement={placementBottom ? 'bottom' : 'right'}
          disableHoverListener={!overflowing}
        >
          <p className={classes.overflowText} style={{ ...styles, width }}>
            {text}
          </p>
        </Tooltip>
      )}
    </div>
  ) : (
    <div />
  );
};

export default TextOverflowTooltip;
